//src/rtkQuery/features/services/contactUs/contactNurseApi.slice.ts
import { baseApi } from "@/rtkQuery/features/services/baseApi";
import { CONTACT_US_ENDPOINTS } from "@/rtkQuery/config/contactUsApi.config";
import type {
  ContactNurseRequest,
  ContactNurseResponse,
} from "@/rtkQuery/features/models/contactNurse.model";
import { buildQuery } from "@/rtkQuery/lib";

export const contactNurseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    requestNurse: builder.mutation<ContactNurseResponse, ContactNurseRequest>({
      query: buildQuery(CONTACT_US_ENDPOINTS.REQUEST_A_NURSE, "POST"),
      transformResponse: (response: ContactNurseResponse, meta) => {
        (meta as any).status = "success";
        (meta as any).error = null;
        return response;
      },
      transformErrorResponse: (response: any, meta) => {
        const errorMessage =
          response.data?.message || "Failed to contact nurse";
        (meta as any).status = "error";
        (meta as any).error = errorMessage;

        return {
          status: response.status,
          message: errorMessage,
          errors: response.data?.errors || [],
        };
      },
    }),
  }),

  overrideExisting: false,
});

export const { useRequestNurseMutation } = contactNurseApi;
